<div class="card-display-container scale" [class.selected]="selected">
    <img src="assets/card-logo/{{card.cardType}}.png" class="card-image" slot="start" alt="">
    <div class="card-holder-name">{{!!card.personName ? card.personName : card.contact.name}}</div>
    <div class="last-four">{{card.lastFour}}</div>
    <div class="expiration-date">{{card.expiration | expiration}}</div>
    <ion-button *ngIf="!hideButton" [color]="buttonColor" (click)="clickAction($event)">
        {{buttonText}}
    </ion-button>
</div>
